import React from 'react';
import { Icon } from './Icon.js';
export const IconAwardFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m6,9.5c-1.107,0-2.136-.331-3-.896v2.895c0,.399.445.638.777.416l2.223-1.482,2.223,1.482c.332.221.777-.017.777-.416v-2.895c-.864.565-1.893.896-3,.896Z", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" }),
        React.createElement("circle", { cx: "6", cy: "4", r: "4", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconAwardFill12.js.map